import { color, Common } from '@stockbit/ui';
import numeral from 'numeral';
import { useDispatch, useSelector } from 'react-redux';
import alertMessage from 'global/AlertMessage';
import TextContent from '../TextContent';
import PollingOption from './PollingOption';
import {
  Container,
  ContentWrapper,
  PollingContent,
  PollingHeader,
  PollingWrapper,
} from './styled';

import { selectors, effects } from '../slice';
import { StreamPostData } from '../../../../@types/stream';
import YoutubePlayer from '../Post/YoutubePlayer';

const { Text } = Common;

interface PollingContainerProps {
  post: StreamPostData;
  isSinglePost: boolean;
  isTextDefaultExpand?: boolean;
  highlightWord?: string;
}

function PollingContainer({
  post,
  isSinglePost,
  isTextDefaultExpand,
  highlightWord = '',
}: PollingContainerProps) {
  const dispatch = useDispatch();

  // select data
  const {
    postVotePolling: { isLoading },
  } = useSelector(selectors);

  const {
    content,
    content_original: contentOriginal,
    mask_html: maskedHtml,
  } = post;
  const polling = post.polling[0];
  const { id: pollingId, my_vote: choiceKey, expired } = polling;

  const filled = choiceKey !== -1;
  // const filled = choiceKey !== '';

  const getOptionPercentage = (voteCount) => {
    const { total_voters: total } = polling;
    // eslint-disable-next-line no-mixed-operators
    const percentage = (voteCount / total) * 100;

    return `${numeral(percentage).format('0,0')}%`;
  };

  const handleVote = async (optionId) => {
    const payload = {
      pollingId,
      optionId,
      postid: post.postid,
    };

    if (filled) return;
    // @ts-ignore
    const votePolling = await dispatch(effects.postVotePolling(payload));

    // @ts-ignore
    const { error } = votePolling.payload;

    if (error) {
      alertMessage({
        content: error?.message,
        messageType: 'error',
        alertType: 'plain-default',
        hasCloseIcon: false,
      });
    }
  };

  const autoplayYoutube = !isSinglePost;

  return (
    <PollingWrapper>
      <ContentWrapper>
        <Container>
          <PollingHeader>
            <Text color={color.nobel}>POLL</Text>
            <TextContent
              family="bold"
              content={content}
              maskedHtml={maskedHtml}
              style={{ marginBottom: '0px' }}
              isDefaultExpand={isTextDefaultExpand}
              size="14.5px"
              color={color.nero}
              highlightWord={highlightWord}
            />
          </PollingHeader>
          <YoutubePlayer content={contentOriginal} autoplay={autoplayYoutube} />
          <PollingContent>
            {polling.options.map((item) => (
              <PollingOption
                key={item.id}
                textPolling={item.value}
                pollingValue={getOptionPercentage(item.count_voters)}
                fill={filled}
                onClick={() => handleVote(item.id)}
                isChoice={choiceKey === item.id}
                isLoading={isLoading}
              />
            ))}

            <Text size="13px" color={color.suvaGrey}>
              {polling.total_voters} votes · {polling.message_expired}
            </Text>
          </PollingContent>
        </Container>
      </ContentWrapper>
    </PollingWrapper>
  );
}

export default PollingContainer;
